import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Base64ImagesTooLargeDialogProps = {
  open: boolean;
  handleClose: () => void;
};

export const Base64ImagesTooLargeDialog = (props: Base64ImagesTooLargeDialogProps) => {
  const { open, handleClose } = props;

  const { t } = useTranslation(['groupMessage']);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='base64-images-too-large-dialog-title'
      aria-describedby='base64-images-too-large-dialog-description'
    >
      <DialogTitle id='base64-images-too-large-dialog-title'>{t('groupMessage:base64ImagesTooLarge.dialogHeader')}</DialogTitle>
      <DialogContent>
        <DialogContentText id='base64-images-too-large-dialog-description'>
          {t('groupMessage:base64ImagesTooLarge.dialogDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={handleClose} variant='contained' disableElevation autoFocus>
          {t('groupMessage:base64ImagesTooLarge.closeButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
